const LOCATION_SCENE_PREFIX = 'web:psn:primary nav:';
const LOCATION_SCENE_MAX_LENGTH = 128;
const PRIMARY_NAV_LOCATION = 'web:psn:primary';
const PRIMARY_NAV_LOCATION_TYPE = 'web primary navigation';

/**
 * Sets locationScene on shared-nav telemetry events (nav clicks, logo, search).
 */
export default (section) => {
  const category = section == null ? '' : String(section).trim();
  const locationScene = category
    ? `${LOCATION_SCENE_PREFIX}${category}`.slice(0, LOCATION_SCENE_MAX_LENGTH)
    : '';

  return {
    location: locationScene || PRIMARY_NAV_LOCATION,
    locationType: PRIMARY_NAV_LOCATION_TYPE,
    locationScene,
  };
};
